export default __webpack_public_path__ + "static/media/Kajal.f5440f44.jpeg";